import { get } from 'store/http/httpAction';
import { SET_DATA, SET_REPORTS, SET_FETCH_STATUS } from './actionTypes';

const setData = data => ({
  type: SET_DATA,
  payload: { data }
});

export const tryFetchReportFoldersIfNeeded = () => (dispatch, getState) => {
  const { metaData } = getState();
  if (metaData && metaData.reportFolders && metaData.reportFolders.isFetched) {
    return console.log('Fetched before');
  }
  return get('/admin/report_folder/me', {}, dispatch).then(data => {
    dispatch(setData(data));
  });
};

export const setFetchStatus = nextStatus => ({
  type: SET_FETCH_STATUS,
  payload: { isFetched: nextStatus }
});

const setReportsByFolder = (folderId, reports) => ({
  type: SET_REPORTS,
  payload: { folderId, reports }
});

export const tryFetchReportsByFolder = folderId => dispatch =>
  get(`/admin/report/report_folder/${folderId}`, {}, dispatch).then(data => {
    dispatch(setReportsByFolder(folderId, data.data));
  });



// WEBPACK FOOTER //
// ./src/store/metaData/reportFolders/actions.js